import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { AppResource } from 'src/app/app.resource';
import { getMaintenanceMessage } from '../../maintenance/maintenance-check';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  standalone: true,
  imports: [CommonModule],
})
export class MaintenanceComponent extends BaseComponent implements OnInit, OnDestroy {
  // Message set from the back-office when the maintenance mode was enabled
  readonly message = getMaintenanceMessage();

  constructor(resources: AppResource) {
    super(resources);

    this.store.updateSizeXL(true);
    this.store.updateBreadcrumb(false);
    this.store.updateVerticalAlign(true);
    this.store.updateHeader(false);
  }

  override ngOnInit() {}

  ngOnDestroy(): void {
    this.store.updateSizeXL(false);
    this.store.updateBreadcrumb(true);
    this.store.updateVerticalAlign(false);
    this.store.updateHeader(true);
  }
}
